/* GENERATED by frontend/scripts/gen_i18n_index.js from the files in this folder — do not edit by hand.
   Order = file-name prefix order; lib/i18n.js applies each file with _overrideDeep, a later file wins.
   The rule (base 0001–0999, overrides 1000+): see the header of frontend/scripts/gen_i18n_index.js. */
import L0010 from "./0010_base_isqm";
import L0020 from "./0020_base_fs_mapping";
import L0030 from "./0030_base_review_points";
import L0040 from "./0040_base_w10";
import L0050 from "./0050_base_w17";
import L0060 from "./0060_base_gl_heads";
import L0070 from "./0070_base_documents";
import L0080 from "./0080_base_analytics";
import L0090 from "./0090_base_engagement_settings";
import L0100 from "./0100_base_aje";
import L0110 from "./0110_base_app_shell";
import L0120 from "./0120_base_ifrs";
import L0130 from "./0130_base_confirmations";
import L0140 from "./0140_base_digital_audit_tabs";
import L0150 from "./0150_base_invite";
import L0160 from "./0160_base_forms";
import L0170 from "./0170_base_w13";
import L0180 from "./0180_base_w17_8";
import L0190 from "./0190_base_sign_off";
import L0200 from "./0200_base_disclosure";
import L0210 from "./0210_base_w17_review";
import L0220 from "./0220_base_analytics_page";
import L0230 from "./0230_base_install";
import L0240 from "./0240_base_methodology";
import L0250 from "./0250_base_notifications";
import L0260 from "./0260_base_w12";
import L0270 from "./0270_base_misstatements";
import L0280 from "./0280_base_review_form_items";
import L0290 from "./0290_base_resample";
import L0300 from "./0300_base_lead";
import L0310 from "./0310_base_estimates";
import L0320 from "./0320_base_related_parties";
import L0330 from "./0330_base_head_folders";
import L0340 from "./0340_base_going_concern";
import L0350 from "./0350_base_scoping";
import L0360 from "./0360_base_errors";
import L0370 from "./0370_base_planning";
import L0380 from "./0380_base_risk";
import L0390 from "./0390_base_sampling";
import L0400 from "./0400_base_engagements";
import L0410 from "./0410_base_opening_balances";
import L0420 from "./0420_base_fieldwork";
import L0430 from "./0430_base_settings";
import L1000 from "./1000_r10";
import L1010 from "./1010_r25c";
import L1020 from "./1020_r27";
import L1030 from "./1030_b28";
import L1040 from "./1040_b30_team";
import L1050 from "./1050_b31_gates";
import L1060 from "./1060_pr45_docs";
import L1070 from "./1070_b31r_je";
import L1080 from "./1080_d2_locale";
import L1090 from "./1090_ifrs18_mpm";
import L1100 from "./1100_ifrs18_a";
import L1110 from "./1110_pr46r_d";
import L1120 from "./1120_b32f";
import L1130 from "./1130_b32_layer";
import L1140 from "./1140_b33_gates";
import L1150 from "./1150_aje_att";
import L1160 from "./1160_far";
import L1170 from "./1170_b33_ui";
import L1180 from "./1180_b33_data";
import L1190 from "./1190_p51";
import L1200 from "./1200_restatement";
import L1210 from "./1210_b34q";
import L1220 from "./1220_b34f";
import L1230 from "./1230_b34h";
import L1240 from "./1240_b34a";
import L1250 from "./1250_b34g";
import L1260 from "./1260_b34c";
import L1270 from "./1270_b34d";
import L1280 from "./1280_b34e";
import L1290 from "./1290_b34b";
import L1300 from "./1300_b34i";
import L1310 from "./1310_b34j";
import L1320 from "./1320_b34m";
import L1330 from "./1330_b34l";
import L1340 from "./1340_b35c";
import L1350 from "./1350_b34p53s";
import L1360 from "./1360_b34p";
import L1370 from "./1370_p53r";
import L1380 from "./1380_b35x";
import L1390 from "./1390_b35u";
import L1400 from "./1400_b35v";
import L1410 from "./1410_b35w2";
import L1420 from "./1420_r56";
import L1430 from "./1430_r564";
import L1440 from "./1440_b35";
import L1450 from "./1450_r25d";
import L1460 from "./1460_r54";
import L1470 from "./1470_op2";
import L1480 from "./1480_ds_d";
import L1490 from "./1490_ds_e";
import L1500 from "./1500_ds_b";
import L1510 from "./1510_fx_d";
import L1520 from "./1520_sd_g2";
import L1530 from "./1530_sd_g3";
import L1540 from "./1540_sd_g4";
import L1550 from "./1550_sd_g5";
import L1560 from "./1560_sd_g6";
import L1570 from "./1570_fx_a";
import L1580 from "./1580_fx_b";
import L1590 from "./1590_sba";
import L1600 from "./1600_sbb";
import L1610 from "./1610_sb_c";
import L1620 from "./1620_sbd";
import L1630 from "./1630_sbe";
import L1640 from "./1640_s2a2";
import L1650 from "./1650_s2a3";
import L1660 from "./1660_s2a7";
import L1670 from "./1670_s2q5";
import L1680 from "./1680_rhv";
import L1690 from "./1690_s3r4";
import L1740 from "./1740_s3r2";
import L1750 from "./1750_s3r7";
import L1760 from "./1760_s3r8";
import L1770 from "./1770_s3r9";
import L1780 from "./1780_s3c";
import L1790 from "./1790_s3c_re_pick";
import L1810 from "./1810_ocr";
import L1820 from "./1820_s7a_sampling";
import L1830 from "./1830_s7b_fixes";
import L1840 from "./1840_s7d_a";
import L1842 from "./1842_s7d_de";
import L1850 from "./1850_s7d_owner";
import L1860 from "./1860_s7e1_methodology";
import L1870 from "./1870_s7e2_methodology_settings";
import L1880 from "./1880_hfdl_links";
import L1890 from "./1890_hfai_models";
import L1900 from "./1900_s10_live_safety";
import L1910 from "./1910_s10e_alerts";
import L1926 from "./1926_s11b_backups_restore";
import L1931 from "./1931_s11b1a";
import L1950 from "./1950_s11b2_mars";
import L1961 from "./1961_s11c1_ai_errors";
import L1962 from "./1962_s11c2_answers";
import L1966 from "./1966_s11c3c_sampling";
import L1972 from "./1972_s11c2b_finance";
import L1977 from "./1977_s11c3b_screens";
import L1983 from "./1983_s11c3a_mars";
import L1991 from "./1991_s11d1_decisions";
import L1992 from "./1992_s11d2_addon";
import L1993 from "./1993_s11d3_mars_finds";
import L1995 from "./1995_s11d1b_finance";
import L1997 from "./1997_s11d5_col_widths";
import L1998 from "./1998_s11d6_addon2";
import L2000 from "./2000_s11d7a_answers";
import L2001 from "./2001_s11d7b_finance";
import L2100 from "./2100_s12a_ties";
import L2110 from "./2110_s12b_note_numbers";
import L2120 from "./2120_s12c_export";
import L2150 from "./2150_s12f2_fixes";
import L2165 from "./2165_s12f5a_sampling";
import L2170 from "./2170_s12g_far_store";
import L2180 from "./2180_speed1_stored";
import L2190 from "./2190_s13p1_provider_names";
import L2192 from "./2192_s13p4_maintenance";
import L2200 from "./2200_s13p5_fixes";
import L2205 from "./2205_s13p2_dc_refs";
import L2210 from "./2210_s13_p3_speed";

export const I18N_LAYERS = [
  { file: "0010_base_isqm.js", dict: L0010 },
  { file: "0020_base_fs_mapping.js", dict: L0020 },
  { file: "0030_base_review_points.js", dict: L0030 },
  { file: "0040_base_w10.js", dict: L0040 },
  { file: "0050_base_w17.js", dict: L0050 },
  { file: "0060_base_gl_heads.js", dict: L0060 },
  { file: "0070_base_documents.js", dict: L0070 },
  { file: "0080_base_analytics.js", dict: L0080 },
  { file: "0090_base_engagement_settings.js", dict: L0090 },
  { file: "0100_base_aje.js", dict: L0100 },
  { file: "0110_base_app_shell.js", dict: L0110 },
  { file: "0120_base_ifrs.js", dict: L0120 },
  { file: "0130_base_confirmations.js", dict: L0130 },
  { file: "0140_base_digital_audit_tabs.js", dict: L0140 },
  { file: "0150_base_invite.js", dict: L0150 },
  { file: "0160_base_forms.js", dict: L0160 },
  { file: "0170_base_w13.js", dict: L0170 },
  { file: "0180_base_w17_8.js", dict: L0180 },
  { file: "0190_base_sign_off.js", dict: L0190 },
  { file: "0200_base_disclosure.js", dict: L0200 },
  { file: "0210_base_w17_review.js", dict: L0210 },
  { file: "0220_base_analytics_page.js", dict: L0220 },
  { file: "0230_base_install.js", dict: L0230 },
  { file: "0240_base_methodology.js", dict: L0240 },
  { file: "0250_base_notifications.js", dict: L0250 },
  { file: "0260_base_w12.js", dict: L0260 },
  { file: "0270_base_misstatements.js", dict: L0270 },
  { file: "0280_base_review_form_items.js", dict: L0280 },
  { file: "0290_base_resample.js", dict: L0290 },
  { file: "0300_base_lead.js", dict: L0300 },
  { file: "0310_base_estimates.js", dict: L0310 },
  { file: "0320_base_related_parties.js", dict: L0320 },
  { file: "0330_base_head_folders.js", dict: L0330 },
  { file: "0340_base_going_concern.js", dict: L0340 },
  { file: "0350_base_scoping.js", dict: L0350 },
  { file: "0360_base_errors.js", dict: L0360 },
  { file: "0370_base_planning.js", dict: L0370 },
  { file: "0380_base_risk.js", dict: L0380 },
  { file: "0390_base_sampling.js", dict: L0390 },
  { file: "0400_base_engagements.js", dict: L0400 },
  { file: "0410_base_opening_balances.js", dict: L0410 },
  { file: "0420_base_fieldwork.js", dict: L0420 },
  { file: "0430_base_settings.js", dict: L0430 },
  { file: "1000_r10.js", dict: L1000 },
  { file: "1010_r25c.js", dict: L1010 },
  { file: "1020_r27.js", dict: L1020 },
  { file: "1030_b28.js", dict: L1030 },
  { file: "1040_b30_team.js", dict: L1040 },
  { file: "1050_b31_gates.js", dict: L1050 },
  { file: "1060_pr45_docs.js", dict: L1060 },
  { file: "1070_b31r_je.js", dict: L1070 },
  { file: "1080_d2_locale.js", dict: L1080 },
  { file: "1090_ifrs18_mpm.js", dict: L1090 },
  { file: "1100_ifrs18_a.js", dict: L1100 },
  { file: "1110_pr46r_d.js", dict: L1110 },
  { file: "1120_b32f.js", dict: L1120 },
  { file: "1130_b32_layer.js", dict: L1130 },
  { file: "1140_b33_gates.js", dict: L1140 },
  { file: "1150_aje_att.js", dict: L1150 },
  { file: "1160_far.js", dict: L1160 },
  { file: "1170_b33_ui.js", dict: L1170 },
  { file: "1180_b33_data.js", dict: L1180 },
  { file: "1190_p51.js", dict: L1190 },
  { file: "1200_restatement.js", dict: L1200 },
  { file: "1210_b34q.js", dict: L1210 },
  { file: "1220_b34f.js", dict: L1220 },
  { file: "1230_b34h.js", dict: L1230 },
  { file: "1240_b34a.js", dict: L1240 },
  { file: "1250_b34g.js", dict: L1250 },
  { file: "1260_b34c.js", dict: L1260 },
  { file: "1270_b34d.js", dict: L1270 },
  { file: "1280_b34e.js", dict: L1280 },
  { file: "1290_b34b.js", dict: L1290 },
  { file: "1300_b34i.js", dict: L1300 },
  { file: "1310_b34j.js", dict: L1310 },
  { file: "1320_b34m.js", dict: L1320 },
  { file: "1330_b34l.js", dict: L1330 },
  { file: "1340_b35c.js", dict: L1340 },
  { file: "1350_b34p53s.js", dict: L1350 },
  { file: "1360_b34p.js", dict: L1360 },
  { file: "1370_p53r.js", dict: L1370 },
  { file: "1380_b35x.js", dict: L1380 },
  { file: "1390_b35u.js", dict: L1390 },
  { file: "1400_b35v.js", dict: L1400 },
  { file: "1410_b35w2.js", dict: L1410 },
  { file: "1420_r56.js", dict: L1420 },
  { file: "1430_r564.js", dict: L1430 },
  { file: "1440_b35.js", dict: L1440 },
  { file: "1450_r25d.js", dict: L1450 },
  { file: "1460_r54.js", dict: L1460 },
  { file: "1470_op2.js", dict: L1470 },
  { file: "1480_ds_d.js", dict: L1480 },
  { file: "1490_ds_e.js", dict: L1490 },
  { file: "1500_ds_b.js", dict: L1500 },
  { file: "1510_fx_d.js", dict: L1510 },
  { file: "1520_sd_g2.js", dict: L1520 },
  { file: "1530_sd_g3.js", dict: L1530 },
  { file: "1540_sd_g4.js", dict: L1540 },
  { file: "1550_sd_g5.js", dict: L1550 },
  { file: "1560_sd_g6.js", dict: L1560 },
  { file: "1570_fx_a.js", dict: L1570 },
  { file: "1580_fx_b.js", dict: L1580 },
  { file: "1590_sba.js", dict: L1590 },
  { file: "1600_sbb.js", dict: L1600 },
  { file: "1610_sb_c.js", dict: L1610 },
  { file: "1620_sbd.js", dict: L1620 },
  { file: "1630_sbe.js", dict: L1630 },
  { file: "1640_s2a2.js", dict: L1640 },
  { file: "1650_s2a3.js", dict: L1650 },
  { file: "1660_s2a7.js", dict: L1660 },
  { file: "1670_s2q5.js", dict: L1670 },
  { file: "1680_rhv.js", dict: L1680 },
  { file: "1690_s3r4.js", dict: L1690 },
  { file: "1740_s3r2.js", dict: L1740 },
  { file: "1750_s3r7.js", dict: L1750 },
  { file: "1760_s3r8.js", dict: L1760 },
  { file: "1770_s3r9.js", dict: L1770 },
  { file: "1780_s3c.js", dict: L1780 },
  { file: "1790_s3c_re_pick.js", dict: L1790 },
  { file: "1810_ocr.js", dict: L1810 },
  { file: "1820_s7a_sampling.js", dict: L1820 },
  { file: "1830_s7b_fixes.js", dict: L1830 },
  { file: "1840_s7d_a.js", dict: L1840 },
  { file: "1842_s7d_de.js", dict: L1842 },
  { file: "1850_s7d_owner.js", dict: L1850 },
  { file: "1860_s7e1_methodology.js", dict: L1860 },
  { file: "1870_s7e2_methodology_settings.js", dict: L1870 },
  { file: "1880_hfdl_links.js", dict: L1880 },
  { file: "1890_hfai_models.js", dict: L1890 },
  { file: "1900_s10_live_safety.js", dict: L1900 },
  { file: "1910_s10e_alerts.js", dict: L1910 },
  { file: "1926_s11b_backups_restore.js", dict: L1926 },
  { file: "1931_s11b1a.js", dict: L1931 },
  { file: "1950_s11b2_mars.js", dict: L1950 },
  { file: "1961_s11c1_ai_errors.js", dict: L1961 },
  { file: "1962_s11c2_answers.js", dict: L1962 },
  { file: "1966_s11c3c_sampling.js", dict: L1966 },
  { file: "1972_s11c2b_finance.js", dict: L1972 },
  { file: "1977_s11c3b_screens.js", dict: L1977 },
  { file: "1983_s11c3a_mars.js", dict: L1983 },
  { file: "1991_s11d1_decisions.js", dict: L1991 },
  { file: "1992_s11d2_addon.js", dict: L1992 },
  { file: "1993_s11d3_mars_finds.js", dict: L1993 },
  { file: "1995_s11d1b_finance.js", dict: L1995 },
  { file: "1997_s11d5_col_widths.js", dict: L1997 },
  { file: "1998_s11d6_addon2.js", dict: L1998 },
  { file: "2000_s11d7a_answers.js", dict: L2000 },
  { file: "2001_s11d7b_finance.js", dict: L2001 },
  { file: "2100_s12a_ties.js", dict: L2100 },
  { file: "2110_s12b_note_numbers.js", dict: L2110 },
  { file: "2120_s12c_export.js", dict: L2120 },
  { file: "2150_s12f2_fixes.js", dict: L2150 },
  { file: "2165_s12f5a_sampling.js", dict: L2165 },
  { file: "2170_s12g_far_store.js", dict: L2170 },
  { file: "2180_speed1_stored.js", dict: L2180 },
  { file: "2190_s13p1_provider_names.js", dict: L2190 },
  { file: "2192_s13p4_maintenance.js", dict: L2192 },
  { file: "2200_s13p5_fixes.js", dict: L2200 },
  { file: "2205_s13p2_dc_refs.js", dict: L2205 },
  { file: "2210_s13_p3_speed.js", dict: L2210 },
];
